import React, { useContext, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import Sidebar from "../../components/Sidebar";
import { AuthContext } from "../../context/AuthContext";
import Header from "../../components/Header";
import { useTheme } from "../../context/ThemeContext";
import "./index.css";

const DashboardLayout = () => {
  const { accessToken, isAuthenticated, fetchUserData } = useContext(AuthContext);
  const navigate = useNavigate();
  const { isDark } = useTheme();

  useEffect(() => {
    if (!accessToken || !isAuthenticated) {
      navigate("/auth");
      return;
    }

    fetchUserData();
  }, [accessToken, fetchUserData, isAuthenticated, navigate]);

  // Dynamic styles based on theme
  const mainWrapperStyle = {
    backgroundColor: isDark ? '#1e293b' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#1e293b',
  };

  const contentStyle = {
    backgroundColor: isDark ? '#0f172a' : '#ffffff',
    color: isDark ? '#e2e8f0' : '#1e293b',
  };

  return (
    <div id="app__layout">
      <Sidebar />
      <div className="main-wrapper" style={mainWrapperStyle}>
        <Header />
        <main className="page__content" style={contentStyle}>
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
